import { Effect, Layer } from "effect";
import { CurrencySchema } from "../value-objects/Currency";
import { MoneySchema } from "../value-objects/Money";
import { ShippingPolicy } from "./ShippingPolicy";

export const ShippingPolicyFreeOver50: Layer.Layer<
  ShippingPolicy,
  never,
  never
> = Layer.succeed(ShippingPolicy, {
  isFreeShippingEligible(financials) {
    const threshold = MoneySchema.fromNumeric(
      50,
      CurrencySchema.quick("EUR", "€")
    );

    const total = financials.subtotal
      .add(financials.taxes)
      .subtract(financials.discount);

    return Effect.succeed(total.isMore(threshold, "orEqual"));
  },
});
